import * as Sentry from '@sentry/react';

declare global {
  interface Window {
    proxy?: any;
  }
}

function isLocalHost(): boolean {
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

export function initSentry() {
  try {
    // 本地不打 sty envelope；也不开 tracing/replay，避免把整页资源铺进 Sentry。
    if (isLocalHost()) {
      return;
    }
    if (window.proxy || typeof Proxy !== 'undefined') {
      Sentry.init({
        dsn: 'https://1984794e7e37e01605b7ab01406c8737@sty.yuaiweiwu.com/61',
        integrations: [],
        denyUrls: [/http:\/\/localhost(?::\d+)?/, /aienglish-live\.(dev|test)\.aitutor100\.com/],
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      });
      console.log('Sentry initialized successfully');
    } else {
      console.warn('Proxy not supported, skipping Sentry initialization');
    }
  } catch (error) {
    console.warn('Sentry initialization failed:', error);
  }
}
